import { render, staticRenderFns } from "./Hotelnameinfo.vue?vue&type=template&id=2122f97b"
import script from "./Hotelnameinfo.vue?vue&type=script&setup=true&lang=js"
export * from "./Hotelnameinfo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Hotelnameinfo.vue?vue&type=style&index=0&id=2122f97b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports